module.exports = __webpack_public_path__ + "img/uisp-logo.f513c555.jpg";